import { Backend, IApi } from './backend'
import { AxiosResponse } from 'axios'
import { IRequest } from './index'
import IMenu from './../models/menu'

export default class Menu extends Backend {
  static getTableData(
    request: IRequest
  ): Promise<AxiosResponse<{ rows: IMenu[]; count: number }>> {
    const api: IApi = {
      url: '/api/menu/tableData',
      method: 'get',
      data: { request }
    }
    return this.request<{ rows: IMenu[]; count: number }>(api)
  }
  static createOrUpdate(data: any): Promise<AxiosResponse<IMenu>> {
    const api: IApi = {
      url: '/api/menu/createOrUpdate',
      method: 'post',
      data
    }
    return this.request<IMenu>(api)
  }
  static delete(id: number): Promise<AxiosResponse> {
    const api: IApi = {
      url: `/api/menu/${id}`,
      method: 'delete'
    }
    return this.request(api)
  }
}
